import { useEffect, useMemo, useState } from 'react';

import { useModalsContext } from '../../../../contexts';

/**
 * VNCModal hook data
 * @description The hook which processes VNCModal data
 *
 * @author Sergii Goncharuk
 */
const useVNCModalHook = () => {
  const {
    data: { vnc },
  } = useModalsContext();

  const modalData = useMemo(() => vnc, [vnc]);
  const [isValidUrl, setIsValidUrl] = useState(true);
  const rawUrl = modalData?.url;
  const vncPassword = modalData?.password;

  const vncUsername = modalData?.username;

  const vncUrl = useMemo(() => {
    if (!rawUrl) return undefined;
    if (rawUrl.startsWith('/')) {
      const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
      return `${protocol}//${window.location.host}${rawUrl}`;
    }
    return rawUrl;
  }, [rawUrl]);

  useEffect(() => {
    if (!vncUrl) return setIsValidUrl(false);
    if (vncUrl.startsWith('ws://') || vncUrl.startsWith('wss://')) return setIsValidUrl(true);
    setIsValidUrl(false);
  }, [vncUrl]);

  return {
    isValidUrl,
    vncUrl,
    vncPassword,
    vncUsername,
  };
};

export { useVNCModalHook };
